const STORAGE_KEY = "smartly-meals-token";


const getStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return window.localStorage;
};


export const readSessionToken = () => {
  return getStorage()?.getItem(STORAGE_KEY) || null;
};


export const writeSessionToken = (token) => {
  getStorage()?.setItem(STORAGE_KEY, token);
};


export const clearSessionToken = () => {
  getStorage()?.removeItem(STORAGE_KEY);
};